const API_URL = process.env.REACT_APP_API_URL;

async function getJson(url) {
  const response = await fetch(url);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || "Failed to fetch stats");
  }
  return await response.json();
}

export const getNumbers = async () => {
  const res = await getJson(`${API_URL}/api/stats/numbers`);
  return res.data;
};

export const getStudentActivity = async (from, to) => {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  const res = await getJson(`${API_URL}/api/stats/activity?${params.toString()}`);
  return res.data;
};

export const getStudentProgress = async (page, pageSize, search) => {
  const params = new URLSearchParams({ page, pageSize });
  if (search) params.set("search", search);
  const res = await getJson(`${API_URL}/api/stats/progress?${params.toString()}`);
  return { data: res.data, pagination: res.pagination };
};

export const getTrainerActivity = async (from, to) => {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  const res = await getJson(`${API_URL}/api/stats/trainer-activity?${params.toString()}`);
  return res.data;
};
